import { Breadcrumbs, Typography } from "@material-ui/core"
import { Link } from "react-router-dom"


const BreadcrumbsComponent = ({ type, path }) => {

    const formattingText = (text) => {
        if (typeof text !== "string" || !text) return "";

        return text.endsWith("y")
            ? `${text.slice(0, -1)}ies`
            : `${text}s`;
    }

    return (
        <Link href={`/app/${path}`}>
            <Breadcrumbs aria-label="breadcrumb">
                <Typography
                    sx={{
                        color: "#5664d2",
                        fontSize: "22px",
                        fontWeight: 500,
                        letterSpacing: "0.5px",
                        textTransform: "uppercase",
                    }}
                >
                    {formattingText(type)}
                </Typography>
            </Breadcrumbs>
        </Link>
    )
}

export default BreadcrumbsComponent;